import * as React from "react";
import { HoloBadge } from "@/components/Holo";
import { cn } from "@/lib/utils";
import { pillFor, PillInput } from "../packageStatus";

export interface StatusPillProps {
  pkg: PillInput;
  size?: "small" | "medium";
}

const SIZE_CLASS: Record<NonNullable<StatusPillProps["size"]>, string> = {
  small: "px-2.5 py-0.5 text-xs",
  // Same padding and type as HoloBadge "md", so it lines up with the Global badge in the editor header.
  medium: "px-2.5 py-1 text-xs",
};

/** A status label, not a control: no hover or focus styles. */
export const StatusPill: React.FC<StatusPillProps> = ({ pkg, size = "small" }) => {
  const pill = pillFor(pkg);

  if (pill.kind === "updating") {
    return <HoloBadge label={pill.label} size={size === "small" ? "sm" : "md"} className={pill.className} />;
  }

  return (
    <span
      data-kind={pill.kind}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border border-transparent font-semibold",
        SIZE_CLASS[size],
        pill.className
      )}
    >
      {pill.label}
    </span>
  );
};
